import { render } from "./PreenchendoCadastro.vue?vue&type=template&id=f82d8842"
import script from "./PreenchendoCadastro.vue?vue&type=script&lang=js"
export * from "./PreenchendoCadastro.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__